import {
  AdminRevenueEvolutionResponseDTO,
  AdminRevenuePointDTO,
  AdminSummaryResponseDTO,
  ClientExpensesEvolutionResponseDTO,
  ClientExpensesPointDTO,
  ClientSummaryResponseDTO,
  TemporalGranularity
} from './dashboard.dtos';

export const MOCK_ADMIN_SUMMARY: AdminSummaryResponseDTO = {
  kpis: {
    revenue: {
      total: 529763.61,
      transport_amount: 496222.00,
      expenses_repercutidos: 41224.13,
      expenses_no_repercutidos: 12164.18
    },
    margin: {
      total_amount: 190992.24,
      percentage: 36.9
    },
    cancellation_costs: {
      total_amount: 43791.54,
      percentage_on_created: 7.6
    },
    pending_incidents: {
      pending_count: 15,
      total_count: 33,
      claims_count: 2,
      breakdowns_count: 7
    },
    additional_expenses: {
      total_amount: 53388.31,
      repercutidos_amount: 41224.13,
      no_repercutidos_amount: 12164.18
    },
    completed_transports_count: 2772,
    cancelled_transports_count: 240,
    average_ticket: 170.93,
    average_distance_km: 272.0,
    active_drivers_count: 279,
    created_transports_count: 3135
  },
  charts: {
    top_clients_by_revenue: [
      { client_id: 5, client_name: 'Hertz España', revenue: 165000.00, margin: 68000.00, transports_count: 980 },
      { client_id: 4, client_name: 'Clicars', revenue: 142000.00, margin: 59000.00, transports_count: 850 },
      { client_id: 2, client_name: 'AutoHero', revenue: 131000.00, margin: 51000.00, transports_count: 780 },
      { client_id: 8, client_name: 'AutoBack', revenue: 118000.00, margin: 46000.00, transports_count: 710 },
      { client_id: 1, client_name: 'Lynk&Co', revenue: 105000.00, margin: 42000.00, transports_count: 620 },
      { client_id: 3, client_name: 'Walacar', revenue: 94000.00, margin: 36000.00, transports_count: 540 },
      { client_id: 6, client_name: 'OK Mobility', revenue: 86000.00, margin: 31000.00, transports_count: 490 },
      { client_id: 9, client_name: 'G&G Digital Business', revenue: 78000.00, margin: 29000.00, transports_count: 440 },
      { client_id: 10, client_name: 'Renting Credit', revenue: 69000.00, margin: 24000.00, transports_count: 390 },
      { client_id: 11, client_name: 'Ceelink Export Spain', revenue: 62000.00, margin: 21000.00, transports_count: 340 },
      { client_id: 12, client_name: 'CSM Grup Automoció', revenue: 54000.00, margin: 19000.00, transports_count: 290 },
      { client_id: 13, client_name: 'Gloobal', revenue: 48000.00, margin: 16000.00, transports_count: 250 },
      { client_id: 14, client_name: 'Enterprise Mobility', revenue: 41000.00, margin: 13000.00, transports_count: 210 },
      { client_id: 15, client_name: 'Automoviles Sanchez', revenue: 35000.00, margin: 11000.00, transports_count: 180 },
      { client_id: 16, client_name: 'Leaseway España', revenue: 28000.00, margin: 8500.00, transports_count: 140 }
    ],
    additional_expenses_by_client: [
      { client_id: 5, client_name: 'Hertz España', repercutidos: 18500.00, no_repercutidos: 4200.00, total: 22700.00 },
      { client_id: 4, client_name: 'Clicars', repercutidos: 16200.00, no_repercutidos: 3600.00, total: 19800.00 },
      { client_id: 8, client_name: 'AutoBack', repercutidos: 14800.00, no_repercutidos: 3100.00, total: 17900.00 },
      { client_id: 11, client_name: 'Ceelink Export Spain', repercutidos: 13100.00, no_repercutidos: 2800.00, total: 15900.00 },
      { client_id: 10, client_name: 'Renting Credit', repercutidos: 12400.00, no_repercutidos: 2400.00, total: 14800.00 },
      { client_id: 1, client_name: 'Lynk&Co', repercutidos: 11800.00, no_repercutidos: 2200.00, total: 14000.00 },
      { client_id: 12, client_name: 'CSM Grup Automoció', repercutidos: 10900.00, no_repercutidos: 1900.00, total: 12800.00 },
      { client_id: 6, client_name: 'OK Mobility', repercutidos: 9800.00, no_repercutidos: 1800.00, total: 11600.00 },
      { client_id: 14, client_name: 'Enterprise Mobility', repercutidos: 9100.00, no_repercutidos: 1600.00, total: 10700.00 },
      { client_id: 17, client_name: 'Driveland', repercutidos: 8400.00, no_repercutidos: 1500.00, total: 9900.00 },
      { client_id: 2, client_name: 'AutoHero', repercutidos: 7900.00, no_repercutidos: 1300.00, total: 9200.00 },
      { client_id: 9, client_name: 'G&G Digital Business', repercutidos: 7200.00, no_repercutidos: 1200.00, total: 8400.00 },
      { client_id: 16, client_name: 'Leaseway España', repercutidos: 6800.00, no_repercutidos: 1100.00, total: 7900.00 },
      { client_id: 13, client_name: 'Gloobal', repercutidos: 6100.00, no_repercutidos: 950.00, total: 7050.00 },
      { client_id: 18, client_name: 'Delta Automotive', repercutidos: 5600.00, no_repercutidos: 850.00, total: 6450.00 },
      { client_id: 19, client_name: 'Sixt España', repercutidos: 5100.00, no_repercutidos: 800.00, total: 5900.00 },
      { client_id: 3, client_name: 'Walacar', repercutidos: 4700.00, no_repercutidos: 700.00, total: 5400.00 },
      { client_id: 15, client_name: 'Automoviles Sanchez', repercutidos: 4200.00, no_repercutidos: 650.00, total: 4850.00 },
      { client_id: 20, client_name: 'Auto Oja', repercutidos: 3800.00, no_repercutidos: 550.00, total: 4350.00 },
      { client_id: 21, client_name: 'Grupo Adarsa', repercutidos: 3300.00, no_repercutidos: 500.00, total: 3800.00 },
      { client_id: 22, client_name: 'Cota Automoción', repercutidos: 2900.00, no_repercutidos: 400.00, total: 3300.00 },
      { client_id: 23, client_name: 'Automotor Dursan', repercutidos: 2400.00, no_repercutidos: 350.00, total: 2750.00 },
      { client_id: 24, client_name: 'Roche Diagnostics, S.L', repercutidos: 1900.00, no_repercutidos: 250.00, total: 2150.00 },
      { client_id: 25, client_name: 'Talleres V Zaragoza', repercutidos: 1400.00, no_repercutidos: 200.00, total: 1600.00 }
    ]
  }
};

export function getMockAdminRevenueEvolution(granularity: TemporalGranularity = 'MONTH'): AdminRevenueEvolutionResponseDTO {
  const seriesByGranularity: Record<TemporalGranularity, AdminRevenuePointDTO[]> = {
    DAY: [
      { period: '2026-06-01', label: '01 Jun', invoice_transport: 4200.00, expenses_repercutidos: 480.00, expenses_no_repercutidos: 90.00, driver_cost: 2600.00, total_cost: 2690.00, margin: 1990.00, completed_transports: 22 },
      { period: '2026-06-02', label: '02 Jun', invoice_transport: 5100.00, expenses_repercutidos: 550.00, expenses_no_repercutidos: 110.00, driver_cost: 3100.00, total_cost: 3210.00, margin: 2440.00, completed_transports: 27 },
      { period: '2026-06-03', label: '03 Jun', invoice_transport: 4800.00, expenses_repercutidos: 510.00, expenses_no_repercutidos: 80.00, driver_cost: 2950.00, total_cost: 3030.00, margin: 2280.00, completed_transports: 25 },
      { period: '2026-06-04', label: '04 Jun', invoice_transport: 6200.00, expenses_repercutidos: 720.00, expenses_no_repercutidos: 140.00, driver_cost: 3800.00, total_cost: 3940.00, margin: 2980.00, completed_transports: 33 },
      { period: '2026-06-05', label: '05 Jun', invoice_transport: 5900.00, expenses_repercutidos: 680.00, expenses_no_repercutidos: 120.00, driver_cost: 3600.00, total_cost: 3720.00, margin: 2860.00, completed_transports: 31 },
      { period: '2026-06-06', label: '06 Jun', invoice_transport: 3100.00, expenses_repercutidos: 320.00, expenses_no_repercutidos: 60.00, driver_cost: 1900.00, total_cost: 1960.00, margin: 1460.00, completed_transports: 16 },
      { period: '2026-06-07', label: '07 Jun', invoice_transport: 2400.00, expenses_repercutidos: 250.00, expenses_no_repercutidos: 40.00, driver_cost: 1450.00, total_cost: 1490.00, margin: 1160.00, completed_transports: 12 }
    ],
    WEEK: [
      { period: '2026-W18', label: 'Sem 18', invoice_transport: 23500.00, expenses_repercutidos: 2600.00, expenses_no_repercutidos: 480.00, driver_cost: 14200.00, total_cost: 14680.00, margin: 11420.00, completed_transports: 124 },
      { period: '2026-W19', label: 'Sem 19', invoice_transport: 25800.00, expenses_repercutidos: 2900.00, expenses_no_repercutidos: 520.00, driver_cost: 15600.00, total_cost: 16120.00, margin: 12580.00, completed_transports: 136 },
      { period: '2026-W20', label: 'Sem 20', invoice_transport: 27100.00, expenses_repercutidos: 3100.00, expenses_no_repercutidos: 560.00, driver_cost: 16400.00, total_cost: 16960.00, margin: 13240.00, completed_transports: 142 },
      { period: '2026-W21', label: 'Sem 21', invoice_transport: 28400.00, expenses_repercutidos: 3250.00, expenses_no_repercutidos: 600.00, driver_cost: 17200.00, total_cost: 17800.00, margin: 13850.00, completed_transports: 149 },
      { period: '2026-W22', label: 'Sem 22', invoice_transport: 29600.00, expenses_repercutidos: 3400.00, expenses_no_repercutidos: 640.00, driver_cost: 18000.00, total_cost: 18640.00, margin: 14360.00, completed_transports: 155 }
    ],
    MONTH: [
      { period: '2026-01', label: 'Ene', invoice_transport: 78400.50, expenses_repercutidos: 8200.00, expenses_no_repercutidos: 1400.00, driver_cost: 48200.00, total_cost: 49600.00, margin: 37000.50, completed_transports: 410 },
      { period: '2026-02', label: 'Feb', invoice_transport: 82100.20, expenses_repercutidos: 9100.00, expenses_no_repercutidos: 1600.00, driver_cost: 50500.00, total_cost: 52100.00, margin: 39100.20, completed_transports: 435 },
      { period: '2026-03', label: 'Mar', invoice_transport: 95300.00, expenses_repercutidos: 10500.00, expenses_no_repercutidos: 1900.00, driver_cost: 58600.00, total_cost: 60500.00, margin: 45300.00, completed_transports: 502 },
      { period: '2026-04', label: 'Abr', invoice_transport: 89000.00, expenses_repercutidos: 9800.00, expenses_no_repercutidos: 1700.00, driver_cost: 54000.00, total_cost: 55700.00, margin: 43100.00, completed_transports: 470 },
      { period: '2026-05', label: 'May', invoice_transport: 102000.00, expenses_repercutidos: 11200.00, expenses_no_repercutidos: 2100.00, driver_cost: 62000.00, total_cost: 64100.00, margin: 49100.00, completed_transports: 530 },
      { period: '2026-06', label: 'Jun', invoice_transport: 110000.00, expenses_repercutidos: 12500.00, expenses_no_repercutidos: 2300.00, driver_cost: 67000.00, total_cost: 69300.00, margin: 53200.00, completed_transports: 580 }
    ],
    QUARTER: [
      { period: '2025-Q3', label: 'T3 2025', invoice_transport: 220000.00, expenses_repercutidos: 24000.00, expenses_no_repercutidos: 4500.00, driver_cost: 134000.00, total_cost: 138500.00, margin: 105500.00, completed_transports: 1180 },
      { period: '2025-Q4', label: 'T4 2025', invoice_transport: 245000.00, expenses_repercutidos: 27500.00, expenses_no_repercutidos: 5100.00, driver_cost: 149000.00, total_cost: 154100.00, margin: 118400.00, completed_transports: 1310 },
      { period: '2026-Q1', label: 'T1 2026', invoice_transport: 255800.70, expenses_repercutidos: 27800.00, expenses_no_repercutidos: 4900.00, driver_cost: 157300.00, total_cost: 162200.00, margin: 121400.70, completed_transports: 1347 },
      { period: '2026-Q2', label: 'T2 2026', invoice_transport: 301000.00, expenses_repercutidos: 33500.00, expenses_no_repercutidos: 6100.00, driver_cost: 183000.00, total_cost: 189100.00, margin: 145400.00, completed_transports: 1580 }
    ],
    YEAR: [
      { period: '2024', label: '2024', invoice_transport: 780000.00, expenses_repercutidos: 84000.00, expenses_no_repercutidos: 16000.00, driver_cost: 475000.00, total_cost: 491000.00, margin: 373000.00, completed_transports: 4200 },
      { period: '2025', label: '2025', invoice_transport: 920000.00, expenses_repercutidos: 101000.00, expenses_no_repercutidos: 19500.00, driver_cost: 560000.00, total_cost: 579500.00, margin: 441500.00, completed_transports: 4950 },
      { period: '2026', label: '2026', invoice_transport: 556800.70, expenses_repercutidos: 61300.00, expenses_no_repercutidos: 11000.00, driver_cost: 340300.00, total_cost: 351300.00, margin: 266800.70, completed_transports: 2927 }
    ]
  };

  return {
    granularity,
    series: seriesByGranularity[granularity] || seriesByGranularity.MONTH
  };
}

export const MOCK_ADMIN_REVENUE_EVOLUTION: AdminRevenueEvolutionResponseDTO = getMockAdminRevenueEvolution('MONTH');

export const MOCK_CLIENT_SUMMARY: ClientSummaryResponseDTO = {
  kpis: {
    total_spent: 473807.89,
    average_expense: 170.93,
    average_distance_km: 272.0,
    completed_transports_count: 2772,
    additional_expenses_amount: 41224.13,
    cancellation_costs: {
      total_amount: 43791.54,
      percentage_on_created: 7.6
    },
    cancelled_transports_count: 240,
    pending_incidents: {
      pending_count: 15,
      total_count: 33,
      claims_count: 2,
      breakdowns_count: 7
    }
  }
};

export function getMockClientExpensesEvolution(granularity: TemporalGranularity = 'MONTH'): ClientExpensesEvolutionResponseDTO {
  const seriesByGranularity: Record<TemporalGranularity, ClientExpensesPointDTO[]> = {
    DAY: [
      { period: '2026-06-01', label: '01 Jun', total_spent: 3800.00, repercutidos_count: 3 },
      { period: '2026-06-02', label: '02 Jun', total_spent: 4600.00, repercutidos_count: 4 },
      { period: '2026-06-03', label: '03 Jun', total_spent: 4100.00, repercutidos_count: 2 },
      { period: '2026-06-04', label: '04 Jun', total_spent: 5500.00, repercutidos_count: 5 },
      { period: '2026-06-05', label: '05 Jun', total_spent: 5200.00, repercutidos_count: 4 },
      { period: '2026-06-06', label: '06 Jun', total_spent: 2700.00, repercutidos_count: 1 },
      { period: '2026-06-07', label: '07 Jun', total_spent: 1900.00, repercutidos_count: 1 }
    ],
    WEEK: [
      { period: '2026-W18', label: 'Sem 18', total_spent: 21200.00, repercutidos_count: 14 },
      { period: '2026-W19', label: 'Sem 19', total_spent: 23100.00, repercutidos_count: 16 },
      { period: '2026-W20', label: 'Sem 20', total_spent: 24400.00, repercutidos_count: 17 },
      { period: '2026-W21', label: 'Sem 21', total_spent: 25600.00, repercutidos_count: 19 },
      { period: '2026-W22', label: 'Sem 22', total_spent: 26800.00, repercutidos_count: 20 }
    ],
    MONTH: [
      { period: '2026-01', label: 'Ene', total_spent: 71200.00, repercutidos_count: 42 },
      { period: '2026-02', label: 'Feb', total_spent: 74500.00, repercutidos_count: 48 },
      { period: '2026-03', label: 'Mar', total_spent: 84100.00, repercutidos_count: 61 },
      { period: '2026-04', label: 'Abr', total_spent: 79300.00, repercutidos_count: 53 },
      { period: '2026-05', label: 'May', total_spent: 91500.00, repercutidos_count: 67 },
      { period: '2026-06', label: 'Jun', total_spent: 98200.00, repercutidos_count: 72 }
    ],
    QUARTER: [
      { period: '2025-Q3', label: 'T3 2025', total_spent: 195000.00, repercutidos_count: 130 },
      { period: '2025-Q4', label: 'T4 2025', total_spent: 218000.00, repercutidos_count: 145 },
      { period: '2026-Q1', label: 'T1 2026', total_spent: 229800.00, repercutidos_count: 151 },
      { period: '2026-Q2', label: 'T2 2026', total_spent: 269000.00, repercutidos_count: 192 }
    ],
    YEAR: [
      { period: '2024', label: '2024', total_spent: 690000.00, repercutidos_count: 450 },
      { period: '2025', label: '2025', total_spent: 820000.00, repercutidos_count: 540 },
      { period: '2026', label: '2026', total_spent: 498800.00, repercutidos_count: 343 }
    ]
  };

  return {
    granularity,
    series: seriesByGranularity[granularity] || seriesByGranularity.MONTH
  };
}

export const MOCK_CLIENT_EXPENSES_EVOLUTION: ClientExpensesEvolutionResponseDTO = getMockClientExpensesEvolution('MONTH');
